<template>
  <div class="wrapper">
    <div
      class="bg-card personalData"
      @click="$router.push({ name: 'user-profile' })"
    >
      <div class="d-flex justify-content-between">
        <strong>{{ $t('pages.user-cv.personal-data.title', 'My personal data') }}</strong>
        <b-button
          variant="info"
          class="edit-button displayHover"
        >
          {{ $t('generic.edit', 'Edit') }}
        </b-button>
      </div>
      <hr>
      <div class="d-flex justify-content-between flex-wrap flex-column-reverse flex-sm-row">
        <div>
          <h2>{{ $auth.user().first_name }} {{ $auth.user().last_name }}</h2>
          <p v-if="$auth.user().city && $auth.user().country && $auth.user().zip">
            {{ $auth.user().city }} ({{ $auth.user().country }}) {{ $auth.user().zip }}
          </p>
          <p>{{ $auth.user().email }}</p>
        </div>
        <img
          class="cv-avatar mx-auto mr-sm-0 mb-3 mb-sm-0"
          :src="basepath + 'uploads/avatars/' + $auth.user().avatar.filename"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    basepath() {
      return process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH;
    }
  }
}
</script>


<style scoped lang="scss">
  .cv-avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  .bg-card.personalData {
    cursor: pointer;

    &:hover {
      background: #dae3e6;

      .edit-button.displayHover {
        visibility: visible;
      }
    }

    .edit-button.displayHover {
      visibility: hidden;
    }
  }

  .edit-button {
    font-size: 0.8rem;
    font-weight: 600;
    padding: 4px 8px;
    text-transform: uppercase;
  }
</style>
